
<template>
<vs-row class="mb-4" >
  <vs-col  class="w-full" >
    <vs-alert  :title="pendingShelterFeesCount+' '+$t('pending_shelter_fees')+'. '+$t('do_you_want_send_shelter_fee')" active="true" color="#842993" v-show="show">
     <a class="cursor-pointer" style="color:#842993" @click.prevent="openConfirm"> <u><b>{{$t('click_to_send')|capitalize}}</b></u> </a>
    </vs-alert>
  </vs-col>

  <vs-popup :title="$t('confirm')|capitalize" :active.sync="popupActive">
          <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-2"
        >
          <vs-col>
            {{ $t('are_you_sure') }} {{ $t('once_the_email_is_sent_you_can_not_undo_this_action') }}.
          </vs-col>
        </vs-row>

          <vs-row vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
            class="mx-1"
          >
            <vs-button @click="popupActive=false" type="border" color="primary" :disabled="loading.submit">{{
            $t('cancel') | capitalize
          }}</vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
            class="mx-1" 
          >
            <vs-button type="filled" color="primary" @click="submit" :disabled="loading.submit">
            {{$t('send')|capitalize}}
          </vs-button>
          </vs-col>
        </vs-row>
    </vs-popup>
</vs-row>
</template>

<script>
import invoice from '@/http/requests/invoice'
export default ({
  data () {
    return {
      loading:{
        submit:false
      },
      popupActive:false,
      show:false,
      pendingShelterFeesCount:0
    }
  },
  methods: {
    checkCountPendingShelterFees(){
      let params={
        count:true
      }
      invoice.sendPendingShelterFees(params).then( res => {
        this.pendingShelterFeesCount=Number(res.data.count)
        if(this.pendingShelterFeesCount>0){
          this.show=true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openConfirm(){
      this.popupActive=true
    },
    submit(){
      this.loading.submit=true
      let params={}
      invoice.sendPendingShelterFees(params).then( res => {
        this.pendingShelterFeesCount=res.data.count
        this.$vs.notify({
          color: 'success',
          title: 'Correct',
          text: 'Sending Email on Background',
        })
        this.loading.submit=false
        this.popupActive=false
        this.show=false
      }).catch(err => {
        this.loading.submit=false
        console.log(err)
      })
    }
  },
  mounted() {
    this.checkCountPendingShelterFees()
  }
})
</script>

